var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 410,
    viewBox: "0 0 405 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.222 323.033H272.133V340.425H276.222V323.033Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.936 323.033V327.792H280.133V335.657H276.936V340.425H284.981V323.033H276.936Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.999 328.515H272.133V334.943H278.999V328.515Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.07 323.033H284.981V340.425H289.07V323.033Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.784 323.033V327.792H292.989V335.657H289.784V340.425H297.837V323.033H289.784Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.847 328.515H284.981V334.943H291.847V328.515Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.927 323.033H297.837V340.425H301.927V323.033Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.641 323.033V327.792H305.837V335.657H302.641V340.425H310.694V323.033H302.641Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.703 328.515H297.837V334.943H304.703V328.515Z",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M314.783 323.033H310.694V340.425H314.783V323.033Z",
    fill: "#263238"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M315.497 323.033V327.792H318.694V335.657H315.497V340.425H323.542V323.033H315.497Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M317.56 328.515H310.694V334.943H317.56V328.515Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.631 323.033H323.542V340.425H327.631V323.033Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.345 323.033V327.792H331.542V335.657H328.345V340.425H336.398V323.033H328.345Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M330.408 328.515H323.542V334.943H330.408V328.515Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M340.488 323.033H336.398V340.425H340.488V323.033Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M341.202 323.033V327.792H344.398V335.657H341.202V340.425H349.255V323.033H341.202Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M343.264 328.515H336.398V334.943H343.264V328.515Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M353.335 323.033H349.246V340.425H353.335V323.033Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M354.05 323.033V327.792H357.255V335.657H354.05V340.425H362.103V323.033H354.05Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M356.112 328.515H349.246V334.943H356.112V328.515Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M367.308 340.13C366.382 340.266 365.449 340.343 364.514 340.363L363.13 340.425H362.103V323.033H363.13L363.781 322.988C364.209 322.989 364.636 322.953 365.058 322.881L367.308 340.13Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.496 322.819L366.255 327.515C367.13 327.381 367.995 327.187 368.844 326.934L371.165 334.461C369.966 334.81 368.746 335.084 367.513 335.282L368.272 339.988C371.924 339.403 375.449 338.195 378.692 336.416L370.219 321.238C368.744 322.025 367.147 322.559 365.496 322.819Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M369.701 334.095C368.438 334.414 367.156 334.65 365.862 334.8C364.585 334.872 363.183 334.97 362.103 334.943V328.515C363.317 328.515 364.192 328.443 365.21 328.408C366.188 328.292 367.157 328.113 368.112 327.872L369.701 334.095Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M383.334 333.238C382.593 333.809 381.843 334.372 381.084 334.916C380.325 335.461 379.495 335.907 378.692 336.39L370.219 321.212L371.317 320.542C371.656 320.283 371.995 320.024 372.344 319.774L383.334 333.238Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M372.674 319.462L375.799 323.033L376.781 322.14L377.674 321.158L383.584 326.336C383.165 326.801 382.754 327.229 382.325 327.72L380.942 328.979L384.066 332.55C386.863 330.14 389.214 327.257 391.013 324.033L375.835 315.515C375.03 317.012 373.959 318.349 372.674 319.462Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M382.182 326.845C380.363 328.711 378.289 330.31 376.022 331.595L372.888 325.979C374.607 325.013 376.182 323.811 377.567 322.408L382.182 326.845Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M393.325 318.953C392.712 320.729 391.941 322.447 391.021 324.086L375.843 315.569C376.252 314.822 376.598 314.042 376.879 313.239L393.325 318.953Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M377.049 312.828L381.593 314.257L381.932 312.971L382.093 312.328L382.191 311.667L389.95 312.962L389.807 313.855L389.584 314.748C389.423 315.346 389.271 315.953 389.102 316.533L393.646 317.953C393.905 317.06 394.128 316.167 394.352 315.274C394.575 314.382 394.673 313.489 394.816 312.551C394.956 311.641 395.033 310.722 395.048 309.801L395.111 308.426V307.471H377.718V308.462L377.674 309.096C377.677 309.518 377.644 309.939 377.575 310.355C377.486 310.766 377.477 311.194 377.361 311.596C377.245 311.998 377.156 312.426 377.049 312.828Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M389.013 314.114C388.44 316.661 387.508 319.114 386.245 321.399L380.638 318.256C381.591 316.528 382.295 314.673 382.727 312.748L389.013 314.114Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M395.111 303.391H377.718V307.48H395.111V303.391Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M377.718 302.685H382.477V299.489H390.352V302.685H395.111V294.632H377.718V302.685Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M389.629 300.623H383.2V307.489H389.629V300.623Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M394.968 289.766C395.03 290.659 395.075 291.632 395.111 292.561V294.632H377.718V292.614C377.718 292.186 377.656 291.722 377.647 291.32L394.968 289.766Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M377.611 290.882L382.343 290.311L382.138 288.998C382.084 288.561 381.933 288.106 381.834 287.704L389.441 285.695C389.584 286.302 389.78 286.9 389.87 287.481L390.155 289.329L394.878 288.757C394.454 285.079 393.372 281.508 391.682 278.213L376.156 286.07C376.937 287.569 377.431 289.201 377.611 290.882Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M389.048 287.132C389.182 287.775 389.254 288.418 389.361 289.061C389.361 289.382 389.468 289.704 389.495 290.034L389.548 291.007C389.548 291.641 389.629 292.338 389.629 292.918V294.632H383.2V292.918C383.2 292.355 383.156 291.909 383.138 291.4V290.659C383.138 290.418 383.066 290.177 383.031 289.927C382.941 289.445 382.897 288.954 382.79 288.472L389.048 287.132Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M388.7 273.49L389.53 274.615C389.807 274.999 390.03 275.41 390.28 275.802C390.79 276.59 391.252 277.406 391.664 278.249L376.138 286.106C375.96 285.718 375.751 285.344 375.513 284.99C375.397 284.811 375.308 284.615 375.183 284.445L374.79 283.936L388.7 273.49Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M374.531 283.579L378.245 280.597C377.965 280.249 377.667 279.915 377.352 279.597C377.082 279.257 376.783 278.94 376.46 278.651L381.879 272.945C382.342 273.36 382.778 273.804 383.182 274.276C383.614 274.725 384.022 275.196 384.406 275.686L388.129 272.713C385.818 269.837 383.031 267.378 379.888 265.446L370.772 280.258C372.204 281.144 373.475 282.267 374.531 283.579Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M382.281 274.374C384.079 276.258 385.583 278.401 386.745 280.731L381.013 283.624C380.127 281.858 378.98 280.236 377.611 278.811L382.281 274.374Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M374.843 262.928C375.722 263.259 376.58 263.641 377.415 264.071C378.26 264.48 379.08 264.939 379.87 265.446L370.754 280.258C370.401 280.018 370.027 279.809 369.638 279.633C369.265 279.431 368.877 279.258 368.478 279.115L374.843 262.928Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M368.058 278.963L369.665 274.499C368.835 274.194 367.985 273.946 367.121 273.758L368.728 266.053C369.939 266.323 371.131 266.669 372.299 267.088L373.906 262.624C370.434 261.389 366.779 260.749 363.094 260.732V278.124C364.784 278.128 366.461 278.411 368.058 278.963Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M369.835 267.062C372.367 267.682 374.78 268.714 376.977 270.115L373.611 275.588C372.771 275.069 371.897 274.607 370.995 274.204C370.082 273.844 369.145 273.546 368.192 273.312L369.835 267.062Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M360.567 260.446C360.987 260.49 361.406 260.598 361.835 260.624C362.264 260.651 362.728 260.624 363.121 260.696V278.088C362.228 278.088 361.255 278.008 360.326 277.945C359.398 277.883 358.469 277.704 357.541 277.57L360.567 260.446Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M356.55 277.392L357.523 272.731C356.311 272.466 355.118 272.12 353.951 271.695L356.63 264.294C357.461 264.595 358.311 264.842 359.174 265.035L360.157 260.374C358.514 260.022 356.945 259.385 355.523 258.491L346.362 273.276C349.492 275.231 352.94 276.624 356.55 277.392Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M357.282 265.303C359.178 265.85 361.138 266.15 363.112 266.196V272.615C360.503 272.581 357.911 272.194 355.407 271.463L357.282 265.303Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M353.451 256.955L353.925 257.392L354.442 257.767L354.951 258.16C355.121 258.285 355.317 258.383 355.496 258.491L346.362 273.276C345.961 273.026 345.559 272.794 345.175 272.526L344.041 271.687L342.925 270.838C342.568 270.544 342.22 270.222 341.871 269.946L353.451 256.955Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M341.121 269.249L344.407 265.803C343.944 265.385 343.508 264.938 343.104 264.464C342.668 264.019 342.259 263.547 341.88 263.053L348.041 258.151C348.316 258.504 348.614 258.838 348.934 259.151C349.206 259.492 349.505 259.811 349.826 260.107L353.112 256.66C351.896 255.494 350.888 254.129 350.13 252.625L334.577 260.41C336.232 263.712 338.446 266.702 341.121 269.249Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348.148 259.348C349.434 260.835 350.939 262.118 352.612 263.151L349.228 268.615C347.005 267.251 345.003 265.556 343.291 263.589L348.148 259.348Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M349.193 250.259C349.441 251.073 349.757 251.864 350.139 252.625L334.586 260.41C333.746 258.732 333.053 256.985 332.515 255.187L349.193 250.259Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M332.265 254.241L336.872 253.035C336.699 252.448 336.556 251.852 336.443 251.25L336.166 249.393L343.978 248.5L344.175 249.821C344.228 250.259 344.389 250.714 344.478 251.107L349.085 249.902C348.964 249.502 348.875 249.093 348.818 248.678C348.742 248.265 348.688 247.848 348.657 247.429C348.657 246.991 348.612 246.607 348.585 246.134V244.08H331.184V246.089C331.184 246.982 331.256 247.875 331.309 248.821C331.363 249.768 331.541 250.652 331.666 251.562C331.809 252.467 332.008 253.362 332.265 254.241Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M343.407 249.482C343.719 251.432 344.337 253.322 345.237 255.08L339.488 257.955C338.306 255.626 337.49 253.13 337.068 250.553L343.407 249.482Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M348.586 239.964H331.193V244.054H348.586V239.964Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M331.193 239.25H335.952V236.054H343.827V239.25H348.586V231.197H331.193V239.25Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M343.104 237.188H336.675V244.054H343.104V237.188Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M348.586 227.108H331.193V231.197H348.586V227.108Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M331.193 226.403H335.952V223.197H343.827V226.403H348.586V218.349H331.193V226.403Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M343.104 224.331H336.675V231.197H343.104V224.331Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M338.988 214.278L321.372 195.761V170.012",
    stroke: "#263238",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M340.229 214.278L357.844 195.761V170.012",
    stroke: "#263238",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M342.893 227.632C350.034 226.478 354.887 219.753 353.733 212.612C352.579 205.471 345.855 200.618 338.714 201.772C331.573 202.926 326.719 209.65 327.874 216.791C329.028 223.932 335.752 228.786 342.893 227.632Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M347.742 217.615C349.345 213.769 347.526 209.352 343.68 207.75C339.834 206.147 335.417 207.966 333.814 211.812C332.211 215.658 334.03 220.075 337.876 221.678C341.723 223.28 346.14 221.461 347.742 217.615Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M160.217 319.872H156.119V337.265H160.217V319.872Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M155.414 337.265V332.497H152.2V324.631H155.414V319.872H147.343V337.265H155.414Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M160.226 325.354H153.343V331.782H160.226V325.354Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.191 319.694C144.7 319.765 145.227 319.747 145.745 319.792H146.513H146.905H147.343V337.184H146.754H146.12L144.843 337.122C143.995 337.068 143.147 337.059 142.298 336.952L144.191 319.694Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M141.423 336.854L142.039 332.14L140.254 331.863C139.651 331.797 139.054 331.683 138.468 331.524L140.191 323.845C140.651 323.974 141.119 324.066 141.593 324.122L142.995 324.336L143.611 319.613C142.607 319.495 141.614 319.304 140.638 319.042L139.165 318.676L137.745 318.14L131.62 334.425L133.986 335.274L136.424 335.916C138.066 336.347 139.737 336.66 141.423 336.854Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M141.102 324.765C142.129 324.899 143.156 325.113 144.191 325.202L147.343 325.354V331.783C146.129 331.783 144.852 331.667 143.611 331.604C142.37 331.542 141.138 331.256 139.897 331.077L141.102 324.765Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M134.977 316.899C135.886 317.394 136.829 317.823 137.799 318.185L131.674 334.47C130.071 333.883 128.508 333.191 126.995 332.399L134.977 316.899Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M126.201 331.961L128.469 327.774L125.424 325.926L129.79 319.381L132.218 320.863L134.495 316.676L133.201 315.881C132.757 315.637 132.33 315.362 131.924 315.06C131.092 314.478 130.298 313.843 129.549 313.158L118.005 326.167C119.252 327.287 120.563 328.334 121.933 329.3C122.615 329.797 123.321 330.259 124.049 330.684L126.201 331.961Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.299 320.515L131.629 321.328C132.076 321.613 132.522 321.792 133.031 322.033L134.433 322.712C134.906 322.944 135.406 323.086 135.897 323.274L133.629 329.292C133.049 329.059 132.442 328.881 131.843 328.613L130.156 327.801C129.594 327.515 129.004 327.283 128.477 326.952L126.87 325.979L130.299 320.515Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M127.361 310.98L128.397 312.123L129.549 313.158L118.005 326.167L116.121 324.435C115.532 323.819 114.96 323.185 114.389 322.56L127.361 310.98Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 321.908L117.406 318.81C117.003 318.373 116.627 317.911 116.281 317.426L115.219 315.997L121.63 311.435L122.522 312.578C122.79 312.97 123.088 313.341 123.415 313.685L127.031 310.587C126.684 310.214 126.367 309.814 126.085 309.391L125.192 308.185L124.406 306.882C124.125 306.46 123.875 306.018 123.656 305.56L108.228 313.596C108.605 314.345 109.019 315.075 109.469 315.783L110.791 317.935L112.291 319.953C112.753 320.632 113.254 321.285 113.791 321.908Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M121.665 312.685C121.987 313.096 122.263 313.578 122.621 313.917L123.674 315.078C124.01 315.475 124.368 315.854 124.746 316.212L125.906 317.265L121.638 322.069L120.255 320.81C119.781 320.399 119.362 319.917 118.96 319.444L117.701 318.06C117.273 317.596 116.933 317.069 116.549 316.578L121.665 312.685Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M122.344 302.748C122.698 303.712 123.115 304.652 123.594 305.56L108.166 313.596C107.378 312.083 106.683 310.524 106.085 308.926L122.344 302.748Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M105.782 308.096L110.246 306.489C110.041 305.926 109.817 305.373 109.648 304.81L109.201 303.078L116.826 301.123L117.174 302.507C117.308 302.962 117.496 303.4 117.648 303.846L122.112 302.248C121.425 300.343 120.958 298.366 120.719 296.355L103.514 298.311C103.893 301.648 104.654 304.932 105.782 308.096Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M116.406 302.31C116.532 302.815 116.693 303.31 116.889 303.793L117.424 305.257C117.6 305.747 117.808 306.224 118.049 306.685L118.728 308.096L113.032 311.042L112.219 309.346C111.928 308.792 111.674 308.219 111.46 307.632L110.817 305.846C110.584 305.265 110.39 304.668 110.237 304.06L116.406 302.31Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M120.585 293.239L120.674 294.811C120.719 295.32 120.674 295.846 120.772 296.355L103.514 298.31C103.327 296.623 103.291 294.891 103.211 293.239H120.585Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M103.193 292.525H107.96V289.32H115.826V292.525H120.594V288.489L120.585 286.454L120.469 283.945L103.103 284.972L103.193 286.49V288.489V292.525Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M115.121 290.454V292.177C115.121 292.748 115.121 293.346 115.121 293.846C115.201 294.891 115.192 295.936 115.317 296.971L108.934 297.694C108.782 296.453 108.773 295.195 108.701 293.945C108.701 293.302 108.701 292.757 108.701 292.159V290.436L115.121 290.454Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M119.88 278.901C120.191 280.576 120.388 282.27 120.469 283.972L103.103 284.998C103.064 283.967 102.948 282.941 102.755 281.927L119.88 278.901Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.684 281.374L107.353 280.481C107.157 279.588 106.88 278.642 106.666 277.722L114.21 275.499C114.496 276.651 114.826 277.793 115.103 278.954L119.781 278.061C119.621 277.24 119.389 276.427 119.183 275.615C118.978 274.803 118.79 273.981 118.514 273.187L117.621 270.821L117.174 269.633C117.023 269.249 116.826 268.874 116.648 268.49L100.836 275.615C100.943 275.847 101.068 276.07 101.166 276.302L101.416 277.017L101.943 278.436C102.121 278.91 102.202 279.418 102.336 279.901C102.469 280.383 102.621 280.874 102.684 281.374Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.826 276.865L114.29 278.651C114.415 279.267 114.496 279.883 114.594 280.508L114.871 282.365C114.951 282.981 114.951 283.606 114.996 284.231L108.576 284.615C108.576 284.088 108.576 283.57 108.487 283.052L108.246 281.579C108.157 281.061 108.103 280.543 108.005 280.035L107.612 278.517L113.826 276.865Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M114.228 263.91C114.648 264.651 115.121 265.347 115.505 266.124L116.612 268.428L100.836 275.615L100.175 274.231C99.9387 273.772 99.6795 273.325 99.3982 272.892L114.228 263.91Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0946 272.437L103.121 269.892C102.628 269.081 102.082 268.302 101.487 267.562L107.737 262.776C108.478 263.704 109.158 264.68 109.773 265.696L113.799 263.151L113.139 262.08C112.907 261.732 112.648 261.401 112.398 261.062L110.898 259.053C110.407 258.374 109.8 257.785 109.246 257.16C108.692 256.535 108.13 255.901 107.532 255.321L95.309 267.687C95.6662 268.044 95.9876 268.446 96.3358 268.812C96.6928 269.171 97.0268 269.553 97.3357 269.954L98.2286 271.178C98.3803 271.383 98.541 271.57 98.6839 271.785L99.0946 272.437Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M107.907 264.205C109.367 266.24 110.623 268.414 111.657 270.696L105.809 273.374C104.945 271.474 103.898 269.662 102.684 267.963L107.907 264.205Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M103.684 251.964C104.023 252.223 104.371 252.473 104.702 252.741L105.648 253.634L107.532 255.357L95.309 267.722L94.1573 266.687L93.5859 266.16C93.3895 265.999 93.1752 265.856 92.9698 265.696L103.684 251.964Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5413 265.348L95.3983 261.535L94.2555 260.642C93.8626 260.374 93.4519 260.142 93.0502 259.892L97.175 253.196C97.6839 253.509 98.2018 253.803 98.6928 254.143L100.121 255.205L102.978 251.393C102.3 250.902 101.648 250.375 100.943 249.92L98.8 248.607L97.7196 247.964C97.3536 247.759 96.9697 247.589 96.5947 247.402L94.318 246.312L87.3182 262.232L88.6843 262.892C88.9075 263.008 89.1485 263.098 89.3717 263.223L90.0146 263.624L91.3181 264.41C91.7466 264.714 92.1306 265.053 92.5413 265.348Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8625 254.491C98.8982 255.187 99.8803 255.973 100.88 256.714C101.88 257.455 102.746 258.383 103.684 259.223L99.1661 263.785C98.3804 263.098 97.6304 262.365 96.8358 261.705C96.0412 261.044 95.1751 260.428 94.3091 259.848L97.8625 254.491Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5235 244.554C90.3449 244.804 91.1395 245.116 91.9431 245.446C92.7504 245.721 93.5431 246.037 94.318 246.393L87.3182 262.312C86.8541 262.091 86.3735 261.905 85.8808 261.758C85.3987 261.589 84.9255 261.383 84.4344 261.232L89.5235 244.554Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9166 261.044L85.2201 256.464L83.8363 256.116C83.3838 255.976 82.9211 255.871 82.4524 255.803L83.8988 248.071C84.5021 248.158 85.0988 248.286 85.6844 248.455L87.4165 248.893L88.7111 244.313C87.1006 243.842 85.46 243.481 83.8006 243.232L81.3096 242.857C80.4792 242.786 79.64 242.759 78.8097 242.714L77.9793 260.089C78.4882 260.089 78.9972 260.089 79.5061 260.16L81.006 260.401C81.9902 260.546 82.9629 260.761 83.9166 261.044Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9791 249.036C86.1933 249.366 87.4254 249.616 88.6039 250.027C89.7825 250.437 90.9788 250.839 92.1127 251.366L89.5235 257.25C88.6307 256.803 87.5772 256.518 86.6129 256.134C85.6487 255.75 84.5951 255.598 83.5952 255.312L84.9791 249.036Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9884 242.679L75.2651 242.625H76.3008C76.6043 242.625 77.0686 242.625 77.4882 242.625L78.765 242.688L77.9347 260.062L77.1579 260.017C76.8605 260 76.5624 260 76.2651 260.017H75.2473L74.4705 260.071L73.9884 242.679Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9705 260.098L73.7384 255.339L72.3099 255.41C71.8367 255.41 71.4171 255.544 70.8992 255.607L69.801 247.812C70.3903 247.732 70.9706 247.616 71.5867 247.571L73.3723 247.482L73.1313 242.723C72.301 242.777 71.4617 242.795 70.6314 242.884L68.1404 243.259C66.4816 243.515 64.8413 243.879 63.2299 244.348L67.9886 261.044C68.9568 260.756 69.9444 260.538 70.9439 260.392L72.4438 260.151C72.9527 260.151 73.4616 260.151 73.9705 260.098Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1314 248.348C72.3724 248.232 73.6224 248.196 74.8723 248.134C75.5151 248.089 76.0419 248.134 76.658 248.134L78.524 248.223L78.2204 254.643L76.658 254.562C76.0955 254.562 75.4705 254.562 74.9705 254.562C73.9259 254.634 72.8813 254.652 71.8456 254.741L71.1314 248.348Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M58.364 246.018L60.7657 245.125C61.5599 244.81 62.3742 244.547 63.2031 244.339L67.9886 261.044C67.4883 261.161 66.9986 261.32 66.5244 261.517L65.078 262.044L58.364 246.018Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5959 262.294L62.6674 257.937C61.7746 258.366 60.9353 258.732 60.1139 259.196L56.2837 252.321C57.3194 251.741 58.4175 251.268 59.48 250.741L57.5604 246.384C56.0262 247.062 54.5353 247.834 53.0963 248.696L50.9446 250.009C50.2482 250.473 49.5964 250.991 48.9179 251.491L59.3818 265.374C59.7925 265.08 60.1853 264.749 60.605 264.481L61.9085 263.696C62.7749 263.174 63.6723 262.706 64.5959 262.294Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M57.739 252.384C59.9686 251.238 62.3038 250.311 64.7119 249.616L66.4976 255.794C64.4814 256.372 62.5259 257.143 60.6585 258.098L57.739 252.384Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0073 254.794L46.9001 253.071C47.5162 252.482 48.2393 252.027 48.909 251.5L59.3729 265.383C58.9508 265.679 58.5454 265.998 58.1586 266.338L57.0158 267.383L45.0073 254.794Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M56.614 267.722L53.257 264.348L51.3285 266.446L45.302 261.392C46.1055 260.499 46.8912 259.607 47.7126 258.758L44.3556 255.384C43.7752 255.982 43.2217 256.607 42.6503 257.223C42.0722 257.827 41.5268 258.462 41.0164 259.124C39.9682 260.434 38.9993 261.806 38.1147 263.231L52.8463 272.481C53.3899 271.618 53.9863 270.789 54.632 269.999C54.9387 269.596 55.2728 269.214 55.6319 268.856C55.9355 268.481 56.2569 268.088 56.614 267.722Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6947 260.937L47.9536 259.544C48.3911 259.098 48.8464 258.696 49.3286 258.267L50.7214 257.009C51.1946 256.607 51.7124 256.25 52.2124 255.866L56.0783 261.044C55.6587 261.357 55.1855 261.651 54.8284 261.99L53.6766 263.044C53.2927 263.401 52.882 263.731 52.5249 264.106L51.4803 265.267L46.6947 260.937Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6594 267.713C36.0433 266.946 36.3915 266.169 36.8022 265.419L38.1236 263.231L52.8552 272.481L52.0428 273.802C51.8017 274.249 51.5963 274.695 51.3731 275.186L35.6594 267.713Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1231 275.669L46.784 273.713L46.4715 274.347L46.2305 275.017L45.7394 276.356L38.3379 273.794L38.9539 272.115L39.2664 271.276L39.6503 270.472L35.3112 268.517C34.9419 269.27 34.6199 270.045 34.347 270.838L33.4541 273.213C33.1863 274.008 33.0077 274.829 32.7845 275.642C32.5613 276.454 32.347 277.267 32.2042 278.088L49.275 281.427C49.3464 280.927 49.525 280.445 49.6321 279.954C49.7393 279.463 49.8643 278.972 50.025 278.49L50.5517 277.07C50.7011 276.587 50.8923 276.118 51.1231 275.669Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4093 272.856C39.842 271.681 40.3459 270.533 40.9181 269.419C41.4736 268.289 42.1029 267.198 42.802 266.151L48.159 269.571C47.5912 270.444 47.0812 271.354 46.6322 272.294C46.1484 273.215 45.7307 274.17 45.3823 275.151L39.4093 272.856Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5346 283.159C31.5346 282.731 31.5346 282.267 31.6239 281.883L31.8113 280.615L32.2042 278.088L49.275 281.427L49.0518 282.954L48.9268 283.713C48.9135 283.972 48.9135 284.231 48.9268 284.49L31.5346 283.159Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8554 285.025L44.0966 284.757C44.0966 285.704 43.9806 286.615 44.0073 287.74H36.1326C36.1326 286.722 36.1862 285.49 36.2398 284.311L31.4899 284.034L31.3739 286.543V292.605H48.7661V286.552L48.8554 285.025Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8558 286.597L37.0433 282.856C37.1862 281.615 37.4004 280.383 37.5879 279.142L43.8913 280.374C43.7484 281.409 43.5609 282.436 43.4359 283.472L43.2841 286.597H36.8558Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 292.605H31.3739V296.703H48.7661V292.605Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 297.418H44.0073V300.623H36.1326V297.418H31.3739V305.489H48.7661V297.418Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2841 292.605H36.8558V299.489H43.2841V292.605Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 305.489H31.3739V309.587H48.7661V305.489Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 310.301H44.0073V313.507H36.1326V310.301H31.3739V318.372H48.7661V310.301Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2841 305.489H36.8558V312.373H43.2841V305.489Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 318.372H31.3739V322.47H48.7661V318.372Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2841 318.372H36.8558V325.256H43.2841V318.372Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 322.47H44.0073V325.685H36.1326V322.47H31.3739V330.542H48.7661V322.47Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2841 317.658H36.8558V324.542H43.2841V317.658Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3288 329.193L59.9443 347.711V373.46",
    stroke: "#263238",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0878 329.193L23.4634 347.711V373.46",
    stroke: "#263238",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6391 341.659C49.7793 340.5 54.628 333.773 53.469 326.632C52.31 319.492 45.5821 314.643 38.4419 315.802C31.3017 316.961 26.4529 323.689 27.612 330.83C28.771 337.97 35.4988 342.818 42.6391 341.659Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5253 335.872C44.4651 335.872 47.659 332.678 47.659 328.738C47.659 324.798 44.4651 321.604 40.5253 321.604C36.5855 321.604 33.3917 324.798 33.3917 328.738C33.3917 332.678 36.5855 335.872 40.5253 335.872Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M118.246 144.289C122.032 145.275 125.944 145.687 129.852 145.513L129.576 142.191C129.379 142.191 109.934 143.575 94.9341 125.674L92.3806 127.817C99.0088 135.944 108.078 141.72 118.246 144.289Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0681 163.628C112.219 145.602 128.674 151.387 128.844 151.45L129.995 148.325C129.254 148.048 111.469 141.798 89.8182 161.146L92.0681 163.628Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0502 179.851C112.683 178.672 130.504 155.968 131.254 154.994L128.629 152.959C128.451 153.182 110.969 175.431 91.8627 176.529L92.0502 179.851Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2823 127.817L89.9521 123.094",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1038 159.86L87.9611 165.923",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1126 177.744C92.2134 177.77 89.3204 177.47 86.4879 176.851",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M82.997 165.003L77.8989 165.887",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4523 167.44L79.0775 173.494",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M87.97 168.36L87.7021 173.172",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M84.113 135.683L72.8902 132.924",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5949 138.388L75.3544 139.022",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0414 130.861L78.0418 126.87",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M116.371 175.654L111.442 183.288",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M112.773 174.163L101.47 185.413",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M111.808 165.682L103.407 166.36",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0153 150.825L71.917 154.289L69.2118 157.173L73.0956 156.423L74.9973 159.887L75.4883 155.968L79.3721 155.227L75.8008 153.548L76.2919 149.629L73.5866 152.512L70.0153 150.825Z",
    fill: "#683C8C",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3276 111.871L77.2293 115.326L74.5241 118.21L78.4079 117.469L80.3096 120.933L80.8096 117.014L84.6844 116.264L81.1131 114.585L81.6042 110.666L78.8989 113.549L75.3276 111.871Z",
    fill: "#683C8C",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M287.222 308.105C283.584 308.427 280.017 309.3 276.642 310.694L277.936 313.524C278.106 313.444 294.757 306.096 313.649 317.096L315.212 314.417C306.806 309.352 296.988 307.137 287.222 308.105Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M304.132 282.811C292.105 305.042 275.785 305.132 275.633 305.132V308.239C276.383 308.239 294.007 308.123 306.882 284.266L304.132 282.811Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M299.043 268.535C281.258 276.097 272.758 301.712 272.401 302.793L275.365 303.757C275.445 303.507 283.793 278.401 300.257 271.401L299.043 268.535Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M313.506 315.015L318.81 317.81",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M304.409 286.454L307.025 279.499",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M296.989 271.356C299.533 270.417 302.175 269.767 304.864 269.419",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M311.676 278.731L315.881 276.347",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M308.757 277.365L312.444 270.026",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M306.248 277.347L304.962 273.035",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M319.971 304.882L330.711 303.757",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M311.649 305.185L326.613 299.177",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M318.033 310.373L328.095 310.712",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M278.945 279.918L280.874 271.642",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M282.588 280.097L288.981 266.624",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M286.115 287.24L293.293 283.99",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M327.586 287.106L324.818 284.659L326.283 281.267L323.104 283.15L320.337 280.704L321.14 284.311L317.962 286.186L321.64 286.534L322.444 290.141L323.908 286.757L327.586 287.106Z",
    fill: "#683C8C",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M335.229 323.06L332.461 320.613L333.925 317.221L330.747 319.104L327.979 316.658L328.783 320.265L325.604 322.149L329.283 322.488L330.086 326.095L331.55 322.711L335.229 323.06Z",
    fill: "#683C8C",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M288.391 263.615L285.615 261.178L287.088 257.785L283.909 259.669L281.133 257.223L281.945 260.83L278.767 262.705L282.436 263.053L283.249 266.66L284.713 263.276L288.391 263.615Z",
    fill: "#683C8C",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M102.719 225.161V227.465",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M102.719 199.912V223.072",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8625 207.716V230.581",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M305.587 200.6V204.019",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M305.587 163.101V197.502",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M301.721 174.681V208.653",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M253.053 252.036H249.634",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M290.552 252.036H256.151",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M278.972 248.17H245",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M133.906 252.036H130.477",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M171.404 252.036H137.004",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M159.825 248.17H125.844",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M220.626 237.768H183.824V274.57H220.626V237.768Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M220.626 237.768H183.824V247.482H220.626V237.768Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M184.279 254.973H220.313",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M184.279 262.017H220.313",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M184.279 269.071H220.313",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M217.983 246.518V253.312",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M217.983 255.089V260.107",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M217.983 262.365V267.383",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M179.136 99.9518H225.304C227.232 99.9518 229.08 100.717 230.443 102.08C231.806 103.443 232.572 105.292 232.572 107.219V124.763H171.86V107.219C171.86 105.292 172.625 103.443 173.988 102.08C175.351 100.717 177.2 99.9518 179.127 99.9518H179.136Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M293.177 108.594H111.273C109.419 108.594 107.916 110.097 107.916 111.951V239.84C107.916 241.694 109.419 243.197 111.273 243.197H293.177C295.031 243.197 296.534 241.694 296.534 239.84V111.951C296.534 110.097 295.031 108.594 293.177 108.594Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M286.213 114.826H118.219C116.365 114.826 114.862 116.329 114.862 118.183V233.608C114.862 235.462 116.365 236.965 118.219 236.965H286.213C288.067 236.965 289.57 235.462 289.57 233.608V118.183C289.57 116.329 288.067 114.826 286.213 114.826Z",
    fill: "#E1BCFF",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M226.376 104.452C226.374 104.007 226.24 103.573 225.992 103.204C225.744 102.835 225.392 102.548 224.981 102.379C224.569 102.21 224.117 102.167 223.681 102.255C223.246 102.343 222.845 102.558 222.532 102.873C222.218 103.188 222.005 103.589 221.918 104.025C221.832 104.461 221.877 104.913 222.048 105.324C222.219 105.734 222.507 106.085 222.877 106.332C223.247 106.579 223.681 106.71 224.126 106.71C224.422 106.71 224.715 106.652 224.989 106.538C225.262 106.425 225.511 106.258 225.72 106.048C225.929 105.838 226.094 105.589 226.207 105.315C226.32 105.041 226.377 104.748 226.376 104.452Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M217.93 104.451C217.93 104.004 217.797 103.567 217.548 103.196C217.3 102.824 216.946 102.534 216.533 102.364C216.12 102.193 215.665 102.149 215.227 102.237C214.788 102.325 214.386 102.541 214.07 102.857C213.755 103.174 213.54 103.578 213.454 104.016C213.368 104.455 213.414 104.909 213.586 105.322C213.759 105.735 214.05 106.087 214.422 106.334C214.795 106.581 215.233 106.712 215.68 106.71C215.976 106.71 216.269 106.652 216.543 106.538C216.816 106.425 217.065 106.258 217.274 106.048C217.483 105.838 217.648 105.589 217.761 105.315C217.873 105.041 217.931 104.748 217.93 104.451Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M209.483 104.451C209.483 104.004 209.351 103.567 209.102 103.196C208.853 102.824 208.5 102.534 208.087 102.364C207.674 102.193 207.219 102.149 206.781 102.237C206.342 102.325 205.94 102.541 205.624 102.857C205.309 103.174 205.094 103.578 205.008 104.016C204.922 104.455 204.968 104.909 205.14 105.322C205.313 105.735 205.603 106.087 205.976 106.334C206.349 106.581 206.786 106.712 207.233 106.71C207.53 106.71 207.823 106.652 208.097 106.538C208.37 106.425 208.619 106.258 208.828 106.048C209.037 105.838 209.202 105.589 209.315 105.315C209.427 105.041 209.485 104.748 209.483 104.451Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M217.983 269.651V274.669",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4893 378.897H356.96C359.619 378.897 362.17 379.953 364.05 381.834C365.93 383.714 366.987 386.264 366.987 388.923V408.164H37.4451V388.923C37.4451 387.605 37.705 386.3 38.21 385.082C38.715 383.865 39.4551 382.759 40.388 381.827C41.321 380.896 42.4284 380.158 43.6469 379.655C44.8654 379.152 46.1712 378.895 47.4893 378.897Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M138.915 273.704H265.526C266.843 273.704 268.146 273.964 269.363 274.468C270.579 274.971 271.685 275.71 272.616 276.641C273.547 277.572 274.285 278.677 274.789 279.894C275.293 281.11 275.552 282.414 275.552 283.731V408.164H128.888V283.731C128.888 281.072 129.945 278.521 131.825 276.641C133.705 274.761 136.255 273.704 138.915 273.704Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M247.348 301.73H157.092C155.238 301.73 153.735 303.233 153.735 305.087V366.165C153.735 368.019 155.238 369.522 157.092 369.522H247.348C249.202 369.522 250.705 368.019 250.705 366.165V305.087C250.705 303.233 249.202 301.73 247.348 301.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M164.994 379.156C164.994 378.192 164.708 377.249 164.172 376.448C163.637 375.646 162.875 375.021 161.985 374.652C161.094 374.283 160.114 374.187 159.168 374.375C158.222 374.563 157.354 375.027 156.672 375.709C155.99 376.391 155.526 377.259 155.338 378.205C155.15 379.15 155.246 380.131 155.615 381.021C155.984 381.912 156.609 382.673 157.411 383.209C158.213 383.745 159.155 384.031 160.119 384.031C161.412 384.031 162.652 383.517 163.566 382.603C164.48 381.689 164.994 380.449 164.994 379.156Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M176.583 384.031C179.275 384.031 181.458 381.848 181.458 379.156C181.458 376.464 179.275 374.281 176.583 374.281C173.891 374.281 171.708 376.464 171.708 379.156C171.708 381.848 173.891 384.031 176.583 384.031Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M193.038 384.031C195.73 384.031 197.912 381.848 197.912 379.156C197.912 376.464 195.73 374.281 193.038 374.281C190.345 374.281 188.163 376.464 188.163 379.156C188.163 381.848 190.345 384.031 193.038 384.031Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M205.939 383.638V390.343H212.644V383.638H205.939Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M205.939 374.799V381.504H212.644V374.799H205.939Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M214.474 383.638V390.343H221.179V383.638H214.474Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M214.474 374.799V381.504H221.179V374.799H214.474Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M223.01 383.638V390.343H229.715V383.638H223.01Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M223.01 374.799V381.504H229.715V374.799H223.01Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 294.409H157.084C156.436 294.409 155.815 294.152 155.357 293.696C154.898 293.239 154.64 292.619 154.637 291.971C154.64 291.324 154.898 290.704 155.357 290.247C155.815 289.791 156.436 289.534 157.084 289.534H185.118C185.765 289.534 186.385 289.791 186.842 290.248C187.299 290.705 187.556 291.325 187.556 291.971C187.556 292.292 187.493 292.608 187.37 292.904C187.248 293.2 187.068 293.469 186.842 293.695C186.615 293.921 186.347 294.101 186.051 294.223C185.755 294.346 185.438 294.409 185.118 294.409Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M165.61 296.239C168.302 296.239 170.485 294.057 170.485 291.364C170.485 288.672 168.302 286.49 165.61 286.49C162.918 286.49 160.735 288.672 160.735 291.364C160.735 294.057 162.918 296.239 165.61 296.239Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M275.097 296.141L261.312 310.105V375.254L275.535 389.218",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M129.46 296.141L143.254 310.105V375.254L129.031 389.218",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M155.851 335.22H177.994L191.975 314.373L205.359 335.22H215.126L223.885 348.246L231.411 335.443H245.098",
    stroke: "#E1BCFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 408.164H404.45",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M118.799 353.496C117.773 351.889 118.014 349.925 119.326 349.077C120.638 348.228 122.531 348.871 123.558 350.478C124.585 352.085 124.335 354.05 123.022 354.898C121.71 355.746 119.817 355.103 118.799 353.496Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M112.541 354.05C112.599 354.01 112.662 353.977 112.728 353.951L119.951 350.719C120.306 350.561 120.71 350.55 121.073 350.689C121.437 350.828 121.73 351.105 121.888 351.46C122.047 351.816 122.058 352.219 121.919 352.583C121.78 352.946 121.503 353.239 121.147 353.398L113.916 356.621C113.578 356.784 113.19 356.811 112.833 356.695C112.476 356.579 112.177 356.329 112 355.999C111.823 355.668 111.78 355.281 111.88 354.92C111.981 354.558 112.218 354.25 112.541 354.058V354.05Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M22.892 185.252C21.8742 183.645 22.1153 181.681 23.4277 180.788C24.7402 179.895 26.6329 180.583 27.6508 182.19C28.6686 183.797 28.4365 185.761 27.124 186.654C25.8115 187.547 23.9188 186.859 22.892 185.252Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6333 185.806L16.8297 185.708L24.0527 182.476C24.4079 182.318 24.8111 182.308 25.1736 182.448C25.5361 182.588 25.8282 182.866 25.9857 183.221C26.1431 183.576 26.153 183.979 26.0132 184.342C25.8734 184.704 25.5953 184.997 25.2401 185.154L18.0172 188.377C17.6827 188.515 17.3091 188.523 16.9685 188.402C16.6278 188.28 16.3443 188.037 16.1724 187.719C16.0005 187.4 15.9525 187.03 16.0376 186.678C16.1227 186.327 16.3349 186.019 16.6333 185.815V185.806Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M377.451 228.01C377.058 229.876 375.504 231.126 373.986 230.804C372.469 230.483 371.549 228.706 371.942 226.849C372.335 224.992 373.888 223.733 375.406 224.054C376.924 224.376 377.843 226.17 377.451 228.01Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M382.316 232.009L382.111 231.947L374.683 229.206C374.34 229.056 374.067 228.781 373.921 228.437C373.775 228.092 373.766 227.705 373.896 227.354C374.026 227.004 374.286 226.716 374.621 226.551C374.957 226.385 375.343 226.355 375.701 226.465L383.12 229.206C383.46 229.338 383.739 229.593 383.902 229.92C384.064 230.247 384.098 230.623 383.998 230.975C383.897 231.326 383.669 231.627 383.358 231.818C383.047 232.01 382.675 232.078 382.316 232.009Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M330.292 367.96C329.89 369.826 328.336 371.076 326.818 370.754C325.301 370.433 324.381 368.656 324.774 366.799C325.167 364.942 326.72 363.683 328.247 364.005C329.774 364.326 330.658 366.094 330.292 367.96Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M335.122 371.942L334.916 371.879L327.497 369.138C327.16 368.986 326.893 368.711 326.75 368.37C326.608 368.029 326.599 367.646 326.727 367.299C326.855 366.951 327.109 366.666 327.439 366.498C327.769 366.331 328.15 366.295 328.506 366.397L335.934 369.138C336.278 369.269 336.56 369.524 336.724 369.853C336.888 370.182 336.923 370.561 336.82 370.915C336.718 371.268 336.486 371.57 336.172 371.76C335.857 371.95 335.482 372.015 335.122 371.942Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M296.561 360.076L292.48 358.094L288.409 360.076L287.4 364.54L290.222 368.112H294.748L297.57 364.54L296.561 360.076ZM293.632 365.781H291.338L289.9 363.996L290.409 361.728L292.48 360.719L294.552 361.728L295.061 363.996L293.632 365.781Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M365.621 144.37L361.54 142.379L357.46 144.37L356.46 148.834L359.282 152.405H363.799L366.621 148.834L365.621 144.37ZM362.692 150.075H360.389L358.96 148.289L359.469 146.022L361.54 144.977L363.612 145.986L364.121 148.254L362.692 150.075Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M329.015 122.049L324.935 120.058L320.854 122.049L319.854 126.513L322.676 130.085H327.193L330.015 126.513L329.015 122.049ZM326.086 127.754H323.783L322.354 125.969L322.863 123.701L324.935 122.656L327.006 123.665L327.515 125.933L326.086 127.754Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M113.558 396.03L109.478 394.075L105.407 396.066L104.398 400.53L107.219 404.101H111.746L114.558 400.53L113.558 396.03ZM110.657 401.735H108.335L106.898 399.95L107.407 397.682L109.478 396.673L111.55 397.646L112.058 399.914L110.657 401.735Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8454 310.319L73.7652 308.364L69.6939 310.355L68.685 314.819L71.5063 318.39H76.0329L78.8453 314.819L77.8454 310.319ZM74.9437 316.024H72.6224L71.1849 314.239L71.6938 311.971L73.7652 310.962L75.8365 311.935L76.3454 314.203L74.9437 316.024Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7305 198.198L41.6503 196.207L37.579 198.198L36.5701 202.662L39.3914 206.234H43.918L46.7394 202.662L45.7305 198.198ZM42.802 203.903H40.5075L39.07 202.118L39.5879 199.85L41.6503 198.841L43.6948 199.814L44.2305 202.118L42.802 203.903Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M186.868 257.473L182.797 255.491L178.717 257.473L177.708 261.937L180.529 265.508H185.056L187.877 261.937L186.868 257.473ZM183.94 263.178H181.645L180.217 261.392L180.726 259.125L182.797 258.116L184.868 259.125L185.377 261.392L183.94 263.178Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5177 59.5872H144.236V95.2555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39273 70.8457H95.1305L108.88 59.6497",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M123.049 59.6496L110.335 44.3734H3.95523",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08017 33.115H84.988L95.7822 44.4003",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9253 59.4711L81.6131 53.391H4.5177",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 91.0592L144.164 96.1304L141.191 91.2378",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5177 80.3721H122.969V95.5144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M126.406 91.3181L122.906 96.3894L119.933 91.4877",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9521 38.3647H159.923V95.7734",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M163.351 91.5771L159.851 96.6484L156.878 91.7468",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M397.146 59.5872H257.428V95.2555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M398.271 70.8457H306.533L292.784 59.6497",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M278.615 59.6496L291.329 44.3734H397.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M396.584 33.115H316.676L305.882 44.4003",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M312.739 59.4711L320.051 53.391H397.146",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M254 91.0592L257.5 96.1304L260.473 91.2378",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M397.146 80.3721H278.686V95.5144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M275.258 91.3181L278.758 96.3894L281.731 91.4877",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M311.712 38.3647H241.741V95.7734",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M238.313 91.5771L241.813 96.6484L244.786 91.7468",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M201.359 2.125V95.6752",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M212.617 1V56.0248L201.421 69.7743",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M201.421 83.9524L186.154 71.2296V1.5625",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M174.886 2.6875V45.8913L186.181 56.6766",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M201.252 49.8197L195.163 42.5075V2.125",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M197.921 91.4789L201.421 96.5501L204.403 91.6485",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M222.144 2.125V95.6752",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M218.715 91.4789L222.215 96.5501L225.188 91.6485",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M180.136 50.8464V95.6752",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M176.699 91.4789L180.208 96.5501L183.181 91.6485",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M148.882 176.169V179.369H135.237V190.755H152V194H129V162H152V165.245H135.237V176.169H148.882Z",
    fill: "#263238"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M169.401 162C178.147 162 181.802 164.556 181.802 169.316V171.917C181.802 175.444 179.659 177.637 174.885 178.499C179.975 179.405 181.881 181.753 181.881 185.18V190.156C181.695 191.471 182.08 192.792 183 194H176.697C175.83 192.768 175.479 191.436 175.673 190.111V185.089C175.673 181.463 172.726 180.33 167.558 180.33H163.193V194H157V162H169.401ZM167.825 177.084C172.742 177.084 175.704 176.178 175.704 172.697V169.624C175.704 166.741 173.876 165.236 169.259 165.236H163.224V177.075L167.825 177.084Z",
    fill: "#263238"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M200.924 162C209.333 162 212.848 164.556 212.848 169.316V171.917C212.848 175.444 210.788 177.637 206.197 178.499C211.091 179.405 212.924 181.753 212.924 185.18V190.156C212.746 191.471 213.115 192.792 214 194H207.939C207.105 192.768 206.768 191.436 206.955 190.111V185.089C206.955 181.463 204.121 180.33 199.152 180.33H194.955V194H189V162H200.924ZM199.409 177.084C204.152 177.084 206.985 176.178 206.985 172.697V169.624C206.985 166.741 205.227 165.236 200.788 165.236H194.985V177.075L199.409 177.084Z",
    fill: "#263238"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M219 169.884C219 165.093 223.123 162 231.461 162C239.8 162 244 165.093 244 169.884V186.116C244 190.862 239.877 194 231.461 194C223.046 194 219 190.862 219 186.116V169.884ZM224.991 186.293C224.991 189.164 227.107 190.818 231.461 190.818C235.816 190.818 237.931 189.164 237.931 186.293V169.707C237.931 166.88 235.893 165.182 231.461 165.182C227.03 165.182 224.991 166.88 224.991 169.707V186.293Z",
    fill: "#263238"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M262.409 162C271.144 162 274.802 164.556 274.802 169.316V171.917C274.802 175.444 272.657 177.637 267.896 178.499C272.973 179.405 274.881 181.753 274.881 185.18V190.156C274.695 191.471 275.079 192.792 276 194H269.693C268.81 192.77 268.453 191.437 268.653 190.111V185.089C268.653 181.463 265.72 180.33 260.548 180.33H256.165V194H250V162H262.409ZM260.832 177.084C265.767 177.084 268.716 176.178 268.716 172.697V169.624C268.716 166.741 266.887 165.236 262.283 165.236H256.228V177.075L260.832 177.084Z",
    fill: "#263238"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M202.618 121.862L186.993 148.923C186.897 149.089 186.847 149.277 186.847 149.469C186.847 149.66 186.898 149.848 186.994 150.014C187.09 150.18 187.228 150.317 187.394 150.412C187.56 150.508 187.748 150.558 187.94 150.557H219.188C219.38 150.558 219.568 150.508 219.734 150.412C219.9 150.317 220.038 150.18 220.134 150.014C220.23 149.848 220.281 149.66 220.281 149.469C220.281 149.277 220.231 149.089 220.135 148.923L204.51 121.862C204.415 121.695 204.278 121.556 204.111 121.459C203.945 121.363 203.756 121.312 203.564 121.312C203.372 121.312 203.183 121.363 203.017 121.459C202.85 121.556 202.713 121.695 202.618 121.862Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M202.618 125.129L189.823 147.289C189.728 147.455 189.677 147.643 189.677 147.835C189.678 148.026 189.728 148.214 189.824 148.38C189.92 148.546 190.058 148.683 190.224 148.778C190.39 148.874 190.578 148.924 190.77 148.923H216.358C216.55 148.924 216.738 148.874 216.904 148.778C217.07 148.683 217.208 148.546 217.304 148.38C217.4 148.214 217.45 148.026 217.451 147.835C217.451 147.643 217.4 147.455 217.305 147.289L204.51 125.129C204.415 124.962 204.278 124.824 204.111 124.727C203.945 124.63 203.756 124.579 203.564 124.579C203.372 124.579 203.183 124.63 203.017 124.727C202.85 124.824 202.713 124.962 202.618 125.129Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M202.537 137.7V129.299H204.528V137.7L204.269 143.218H202.787L202.537 137.7ZM204.475 144.691V147.173H202.564V144.691H204.475Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyErr);
export default __webpack_public_path__ + "static/media/verifyErr.6a9c91ed4cc10a6a9e062285529f4a98.svg";
export { ForwardRef as ReactComponent };